
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.004.021a5.9 5.9 0 00-4.822 2.514L1.758.332a1.046 1.046 0 00-.705-.271 1.046 1.046 0 00-.774.341 1.046 1.046 0 00.073 1.479L1.56 2.979a.96.96 0 01.003.003.96.96 0 01.063.053L16.257 16.3a.96.96 0 01.132.144 1.046 1.046 0 001.347-.172 1.046 1.046 0 00.149-1.199.77.77 0 00.101-.383.77.77 0 00-.77-.771h-.513l-1.797-1.633V5.924A5.914 5.914 0 009.004.02zm0 1.542a4.35 4.35 0 014.363 4.36v4.962L5.33 3.578a4.342 4.342 0 013.674-2.015zM3.102 6.965v6.953H.79a.77.77 0 00-.77.771.77.77 0 00.77.77h4.465c.35 1.443 1.649 2.527 3.195 2.527h1.106c1.474 0 2.714-.99 3.13-2.332l-1.916-1.736H4.64V8.359L3.1 6.965zm3.91 8.496h3.984c-.294.552-.763.986-1.44.986H8.452c-.676 0-1.145-.434-1.44-.986zM1.054 1.106l15.908 14.461","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    